import { MathN } from '../math/math-n.js';

class EnumResolver {
    constructor(_name, entries) {
        this._name = _name;
        this._KEY_VALUE_MAP = new Map();
        this._VALUE_KEY_MAP = new Map();
        entries.map(entry => {
            this._KEY_VALUE_MAP.set(entry[MathN.ZERO], entry[MathN.ONE]);
            this._VALUE_KEY_MAP.set(entry[MathN.ONE], entry[MathN.ZERO]);
        });
    }
    get name() {
        return this._name;
    }
    getKeyByValue(value) {
        return this._VALUE_KEY_MAP.get(value);
    }
    getValueByKey(key) {
        return this._KEY_VALUE_MAP.get(key);
    }
}

export { EnumResolver };
//# sourceMappingURL=enum-resolver.js.map
